/**
 * The voice of every group heading: a list's date buckets ("Last month"), a grid's column labels and
 * every menu's group headings (ListSubheader, "Customer lists", "Folders"). One style, so a heading
 * reads as a heading wherever it is, and never as one more option.
 */
export const GROUP_LABEL_SX = {
  fontSize: 11,
  fontWeight: 600,
  letterSpacing: '0.09em',
  textTransform: 'uppercase',
} as const
